import React from "react";

interface Props extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
    label?: React.ReactNode;
}

const ToggleSwitch = React.forwardRef<HTMLInputElement, Props>(function ToggleSwitch(
    { label, className = "", ...rest },
    ref,
) {
    return (
        <label
            className={[
                "group inline-flex cursor-pointer select-none items-center gap-2 text-sm text-ink",
                className,
            ].join(" ")}
        >
            <input ref={ref} type="checkbox" className="sr-only" {...rest} />
            <span className="relative inline-block h-5 w-9 shrink-0 rounded-full bg-surface-3 align-middle transition-colors group-has-[:checked]:bg-accent group-has-[:focus-visible]:ring-2 group-has-[:focus-visible]:ring-accent/40 group-has-[:disabled]:opacity-50">
                <span className="absolute left-0.5 top-0.5 block h-4 w-4 rounded-full bg-white shadow transition-transform group-has-[:checked]:translate-x-4" />
            </span>
            {label && <span className="whitespace-nowrap leading-5">{label}</span>}
        </label>
    );
});

export default ToggleSwitch;
